// extracted by css-extract-rspack-plugin
export default {"overlay":"overlay-nA40QB","pill":"pill-fHeFzS","text":"text-FZh0ot"};